import { render, staticRenderFns } from "./Chats.vue?vue&type=template&id=10296e41&scoped=true"
import script from "./Chats.vue?vue&type=script&lang=js"
export * from "./Chats.vue?vue&type=script&lang=js"
import style0 from "./Chats.vue?vue&type=style&index=0&id=10296e41&prod&lang=postcss&scoped=true"
import style1 from "./Chats.vue?vue&type=style&index=1&id=10296e41&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10296e41",
  null
  
)

export default component.exports